import * as utils from './util/const';
import DEFINE from './util/DEFINE';
import {
  defineExternalLayer,
  defineHXKLineLayer,
  defineNormalLayer,
  defineStandardChartLayer
} from './core/layer';
import { layers } from './layer/all';
import { registerLayer } from './layer';
import './helper/standardChartExtension/index';
import preprocessing from './layer/processorRegistry';

// 注册所有内部layers
layers.forEach(layer => {
  registerLayer(layer);
});

export {
  /** 版本信息 */
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  version as VERSION
  // @ts-ignore
} from '../package.json';

export { render, destroy, update, switchTheme } from './core/api';
export * from './theme';
export * from './hook';
export * from './insight';

// 渲染器注册功能
export {
  type IRenderer,
  type IRendererInstance,
  type IRendererRegistry,
  getRendererRegistry,
  registerRenderer,
  resetRendererRegistry
} from './core/renderer';

export {
  //
  // mapParameter,
  // getWeight,
  //
  utils,
  DEFINE,
  registerLayer,
  defineExternalLayer,
  defineHXKLineLayer,
  defineNormalLayer,
  defineStandardChartLayer,
  preprocessing
};

// 3rd
